import React, { useEffect } from 'react';
import './TermsModal.scss';
import Text from '../components/Text';
import { useRTL } from '../utils/translations';

interface TermsModalProps {
  visible: boolean;
  onClose: () => void;
}

const TermsModal: React.FC<TermsModalProps> = ({ visible, onClose }) => {
  const { isRTL } = useRTL();

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && visible) onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div
      className={`terms-modal__backdrop ${isRTL ? 'rtl' : ''}`}
      role="dialog"
      aria-modal="true"
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <div className="terms-modal__container">
        <button
          className="terms-modal__close"
          aria-label="Close Terms and Conditions"
          onClick={onClose}
        >
          <span className="terms-modal__close-x">×</span>
        </button>

        <div className="terms-modal__content">
          <h2 className="terms-modal__title">
            <Text
              translationKey="staticTranslations.loadingScreen.termsModal.title"
              fallback="Configurator Use Terms and Conditions"
            />
          </h2>

          <p className="terms-modal__lead">
            <Text
              translationKey="staticTranslations.loadingScreen.termsModal.lead"
              fallback="By using this vehicle configurator and submitting your build, you acknowledge and agree to the following:"
            />
          </p>

          <ol className="terms-modal__list">
            {[1, 2, 3, 4, 5, 6, 7].map((num) => (
              <li key={num} className="terms-modal__item">
                <Text
                  translationKey={`staticTranslations.loadingScreen.termsModal.sections.item${num}.title`}
                  fallback={`Section ${num}`}
                />{' '}
                <Text
                  translationKey={`staticTranslations.loadingScreen.termsModal.sections.item${num}.content`}
                  fallback="Content loading..."
                />
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
